/**
 * 用户 Store
 * @author LiQingSong
 */
import { login, getRole } from '@/service/user'
import { localList as getDevices, okq as getOkq } from '@/service/device'
import { list as getCate } from '@/service/category'
import { getHome } from '@/service/page'
import { logo as getLogo } from '@/service/user'
import {
  getToken,
  setToken,
  removeToken,
  getCompanyId,
  setCompanyId,
  setName,
  getName
} from '@/service/lib/localToken'
import { resetRouter } from '@/router'
import { serverLoginUrl, siteLoginRouter } from '@/settings'

const state = {
  token: getToken(),
  name: '',
  companyId: 0,
  companies: [],
  devices: [],
  okq: [], // 欧科奇孢子仪
  categories: [],
  logo: {},
  avatar: '',
  msgtotal: 0,
  role: {},
  homePage: '/home'
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, user) => {
    state.name = user.username
    state.companyId = user.companyId
    state.title = user.title
    state.logo = user.logo
  },
  SET_USER_LOGO: (state, logo) => {
    state.logo = logo
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_MSGTOTAL: (state, msgtotal) => {
    state.msgtotal = msgtotal
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_COMPANYID: (state, companyId) => {
    state.companyId = companyId
  },
  SET_COMPANIES: (state, companies) => {
    state.companies = companies
  },
  SET_DEVICES: (state, devices) => {
    state.devices = devices
  },
  SET_CATEGORIES: (state, cates) => {
    state.categories = cates
  },
  SET_OKQ: (state, devices) => {
    state.okq = devices
  },
  SET_HOME: (state, page) => {
    state.homePage = page
  }
}
const actions = {
  // 用户登录
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login(serverLoginUrl, { username: username, password: password })
        .then(response => {
          const { data } = response
          const { token } = data
          commit('SET_TOKEN', token)
          commit('SET_USER_INFO', data.user)
          setToken(token)
          setCompanyId(data.user.companyId)
          setName(data.user.username)
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  // 获取用户信息
  getRole({ commit, state }) {
    if (!state.token) return
    return new Promise((resolve, reject) => {
      getRole(state.token)
        .then(response => {
          const { data } = response

          if (!data) {
            reject('当前用户登入信息已失效，请重新登入再操作.')
          }

          const { role, companies } = data

          if (!role || !role.id) {
            reject('用户没有角色权限!')
          }

          commit('SET_ROLE', role)
          commit('SET_COMPANIES', companies)
          resolve(role)
        })
        .catch(error => reject(error.msg || 'Error'))
    })
  },

  // 获取用户信息
  getComid({ state }) {
    if (!state.token) return
    return getCompanyId()
  },

  async warmup({ commit, state }) {
    let companyId = state.companyId || getCompanyId()
    let token = state.token || getToken()

    if (companyId && token) {
      let [{ data: devices }, { data: cates }, logo] = await Promise.all([
        getDevices({ companyId }),
        getCate(companyId),
        getLogo(companyId)
      ])

      let username = getName()

      commit('SET_DEVICES', devices)
      commit('SET_CATEGORIES', cates)
      commit('SET_USER_INFO', { username, companyId, logo })
      commit('SET_USER_LOGO', logo.data)

      if (companyId) {
        const home = getHome(companyId, devices)
        commit('SET_HOME', home)
      }

      return [devices, cates]
    }
  },

  // 用户退出
  logout({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLE', {})
      removeToken()
      resetRouter()
      resolve({ isExternal: false, siteLoginRouter: siteLoginRouter })
    })
  },
  // 删除Token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLE', {})
      removeToken()
      resolve()
    })
  },

  setCompanyId({ commit }, companyId) {
    return new Promise(resolve => {
      commit('SET_COMPANYID', companyId)
      setCompanyId(companyId)
      resolve()
    })
  },

  setOkq({ commit }, companyId) {
    return new Promise((resolve, reject) => {
      getOkq(companyId)
        .then(res => {
          if (res.code) {
            commit('SET_OKQ', res.data)
            resolve()
          } else {
            throw new Error()
          }
        })
        .catch(reject)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
